// extracted by mini-css-extract-plugin
export default {"verticalAlignXs":"FVsXLvZdR5G_OQp55JEoq","verticalAlignSm":"_1WNDJ0Z5FAyHtDfm9gHDef","verticalAlignMd":"ge9nhY4IHQCLkPEjA5jcD","verticalAlignLg":"_3pg0EmmczXZapWNBf8Fgu9"};